import React, { useEffect, useState } from 'react';
import OtherIncomeRow from './OtherIncomeRow';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { clearFileUploadStatus, updateOtherIncome } from '../actions';
import { selectFileUploadStatus } from '../purchaseOrderReducer';

interface OtherIncomeFormProps {
  employeeId: number;
  sites: any;
  formReset: any;
  intl: any;
}

// Mirrors VendingSalesForm field-for-field. Same row shape (siteId, amount,
// statementPeriod), same auto-set "previous Saturday" week. The only thing
// that differs is the action it dispatches — `updateOtherIncome` writes to
// `/purchase-orders/other-income`, which inserts into `VendingSales` with
// `category = 'other_income'`.
const OtherIncomeForm = ({ employeeId, sites, formReset, intl }: OtherIncomeFormProps) => {
  const [displayedSites, setDisplayedSites] = useState(10);
  const [validRows, setValidRows] = useState<number[]>([]);
  const dispatch = useDispatch();
  const fileUploadStatus = useSelector(selectFileUploadStatus);
  const form = useForm({
    shouldUseNativeValidation: true,
    progressive: true,
  });
  const showMoreSites = () => {
    setDisplayedSites(displayedSites + 10);
  };
  const hasValidRow = (siteId: number, valid: boolean) => {
    const rowIndex = validRows.indexOf(siteId);
    const newRows = [...validRows];
    if (valid) {
      if (rowIndex == -1) newRows.push(siteId);
    } else {
      if (rowIndex > -1) newRows.splice(rowIndex, 1);
    }
    setValidRows(newRows);
  };
  const handleFormSubmit = (formData: any) => {
    const filteredSales = formData.sales.reduce((result: any, item: any) => {
      if (!isNaN(item.amount)) {
        const filteredRow = {
          siteId: item.siteId,
          amount: item.amount,
          statementPeriod: item.statementPeriod,
        };
        result.push(filteredRow);
      }
      return result;
    }, []);
    dispatch(
      updateOtherIncome({
        employeeId: employeeId,
        sales: filteredSales,
      })
    );
    formReset();
  };
  const handleFormUploadMessage = () => {
    dispatch(clearFileUploadStatus());
  };

  useEffect(() => {
    handleFormUploadMessage();
  }, [fileUploadStatus]);
  return (
    <>
      <div className="vending-sales upload-form enhanced-form">
        <form
          id="otherIncomeTotals"
          name="otherIncomeTotals"
          onSubmit={form.handleSubmit(handleFormSubmit)}
        >
          {sites.slice(0, displayedSites).map((site: any, i: any) => (
            <React.Fragment key={i}>
              <OtherIncomeRow
                site={site}
                form={form}
                index={i}
                validCallback={hasValidRow}
                intl={intl}
              />
            </React.Fragment>
          ))}
        </form>
        {displayedSites < sites.length && (
          <button className="button" onClick={showMoreSites}>
            {intl.formatMessage({ id: 'showMore' })}
          </button>
        )}
      </div>
      <button
        className="button confirm full-width"
        type="submit"
        form="otherIncomeTotals"
        disabled={!validRows.length}
      >
        {intl.formatMessage({ id: 'submit' })}
      </button>
    </>
  );
};

export default OtherIncomeForm;
